import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import "./Use_Reference_Material_Form.css";
import { faCirclePlus, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Create,
  GetAll,
} from "../../../../../../../../../src/features/admin/quality_management/process_requirement/validity/Slice";
import {
  allTestType,
  allTestedBy,
  AllTestMethod,
  allSampleManagement,
} from "../../../../../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useFieldArray, useForm, useWatch } from "react-hook-form";

function Use_Reference_Material_Form({ validityTypeId, onProceed }) {
  const dispatch = useDispatch();

  const [degreePreview, setDegreePreview] = useState(null);
  const degreeInputRef = useRef(null);

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    setValue,
    reset,
    watch,
    getValues,
  } = useForm({
    defaultValues: {
      observations: [{ value: "" }],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "observations",
  });

  const all_test_type = useSelector((state) => state.common.all_test_type);
  const all_teseted_by = useSelector((state) => state.common.all_teseted_by);
  const all_test_method = useSelector((state) => state.common.all_test_method);

  useEffect(() => {
    dispatch(allTestType());
    dispatch(allTestedBy());
    dispatch(AllTestMethod());
  }, [dispatch]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setValue("attach_file", file, { shouldValidate: true });
  };

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("sample_id", data.sample_management_id);
      formData.append("validity_type_id", validityTypeId);
      formData.append("test_type_id", data.test_type_id);
      formData.append("test_method_id", data.test_method_id);
      formData.append("tested_by_id", data.tested_by_id);
      formData.append("certified_value", data.certified_value);
      formData.append("average", data.average);
      formData.append("remark", data.remark);
      data.observations.forEach((o, i) => {
        formData.append(`observations[${i}]`, o.value);
      });

      if (data.attach_file && typeof data.attach_file !== "string") {
        if (data.attach_file.length > 0) {
          formData.append("attach_file", data.attach_file[0]);
        }
      }

      const res = await dispatch(Create(formData));

      if (res.meta.requestStatus === "fulfilled") {
        await dispatch(
          GetAll({
            page: 1,
            per_page: 10,
            validity_type_id: validityTypeId,
          }),
        );

        reset({
          observations: [{ value: "" }],
        });

        setDegreePreview(null);

        if (degreeInputRef.current) {
          degreeInputRef.current.value = "";
        }

        onProceed();
      }
    } catch (error) {
      console.error("Submit error:", error);
    }
  };

  const all_sample_management = useSelector(
    (state) => state.common.all_sample_management,
  );

  useEffect(() => {
    dispatch(allSampleManagement());
  }, [dispatch]);

  const observations = useWatch({
    control,
    name: "observations",
  });
  useEffect(() => {
    if (!observations || observations.length === 0) return;

    const values = observations
      .map((o) => parseFloat(o.value))
      .filter((v) => !isNaN(v));

    const avg =
      values.length > 0
        ? (values.reduce((a, b) => a + b, 0) / values.length).toFixed(2)
        : "";

    setValue("average", avg);
  }, [observations, setValue]);

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        <div className="row">
          {/* Test Type */}
          <div className="col-xl-4 col-md-6">
            <Form.Group className="form_group">
              <Form.Label>Test Type</Form.Label>
              <Controller
                name="test_type_id"
                control={control}
                rules={{ required: "Test Type is required" }}
                render={({ field }) => (
                  <Select
                    options={all_test_type}
                    value={
                      all_test_type?.find((o) => o.value === field.value) ||
                      null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />
              {errors.test_type_id && (
                <Form.Text className="text-danger">
                  {errors.test_type_id.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Sample ID</Form.Label>
              <Controller
                name="sample_management_id"
                control={control}
                rules={{ required: "Sample is required" }}
                render={({ field }) => (
                  <Select
                    options={all_sample_management}
                    value={
                      all_sample_management?.find(
                        (o) => o.value === field.value,
                      ) || null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />
              {errors.sample_management_id && (
                <Form.Text className="text-danger">
                  {errors.sample_management_id.message}
                </Form.Text>
              )}{" "}
            </Form.Group>
          </div>

          {/* Certified Value */}
          <div className="col-xl-4 col-md-6">
            <Form.Group className="form_group">
              <Form.Label>Certified Value</Form.Label>
              <Form.Control
                {...register("certified_value", {
                  required: "Certified value is required",
                })}
              />
              {errors.certified_value && (
                <Form.Text className="text-danger">
                  {errors.certified_value.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Remark</Form.Label>
              <Form.Control
                placeholder="Enter Remark"
                {...register("remark", {
                  required: "Remark is required",
                })}
              />
              {errors.remark && (
                <Form.Text className="text-danger">
                  {errors.remark.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
        </div>

        {/* Observations */}
        <div className="heading_add_text mt-3">
          <Form.Group className="form_group">
            <Form.Label>Enter Observation</Form.Label>
          </Form.Group>
          <span onClick={() => append({ value: "" })}>
            <FontAwesomeIcon icon={faCirclePlus} /> Add Observation
          </span>
        </div>

        <div className="row">
          {fields.map((field, index) => (
            <div key={field.id} className="col-xl-2 col-lg-4  col-md-4">
              <div className="observation_box">
                <div className="obs_label">
                  OBS {String(index + 1).padStart(2, "0")}
                </div>

                <Form.Control
                  {...register(`observations.${index}.value`, {
                    required: "Observation is required",
                  })}
                  onKeyDown={(e) => {
                    const value = e.target.value;

                    // Allow control keys
                    if (
                      [
                        "Backspace",
                        "Delete",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                      ].includes(e.key)
                    ) {
                      return;
                    }

                    // Allow numbers
                    if (/^[0-9]$/.test(e.key)) {
                      return;
                    }

                    // Allow ONE decimal point
                    if (e.key === "." && !value.includes(".")) {
                      return;
                    }

                    // Block everything else
                    e.preventDefault();
                  }}
                />

                {errors.observations?.[index]?.value && (
                  <small className="text-danger">
                    {errors.observations[index].value.message}
                  </small>
                )}

                {fields.length > 1 && (
                  <button type="button" onClick={() => remove(index)}>
                    ❌
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="row mt-3">
          {/* Test Method */}
          <div className="col-xl-4 col-md-6">
            <Form.Group className="form_group">
              <Form.Label>Test Method</Form.Label>
              <Controller
                name="test_method_id"
                control={control}
                rules={{ required: "Test Method is required" }}
                render={({ field }) => (
                  <Select
                    options={all_test_method}
                    value={
                      all_test_method?.find((o) => o.value === field.value) ||
                      null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />

              {errors.test_method_id && (
                <small className="text-danger">
                  {errors.test_method_id.message}
                </small>
              )}
            </Form.Group>
          </div>

          {/* Average */}
          <div className="col-xl-4 col-md-6">
            <Form.Group className="form_group">
              <Form.Label>Average</Form.Label>
              <Form.Control
                {...register("average", {
                  required: "Average is required",
                })}
              />
            </Form.Group>
          </div>
        </div>

        <div className="row">
          {/* Attach File */}
          <div className="col-xl-4 col-md-6">
            <Form.Group className="form_group file_field">
              <Form.Label>Attach File</Form.Label>

              <div className="absolute_fields">
                <Form.Control
                  type="file"
                  {...register("attach_file", {
                    // required:
                    //   typeof getValues("attach_file") === "string"
                    //     ? false
                    //     : "File is required",
                  })}
                  accept="*"
                />
                <div className="upload_icon_holder">
                  <FontAwesomeIcon icon={faUpload} />
                </div>
              </div>

              {errors.attach_file && (
                <small className="text-danger">
                  {errors.attach_file.message}
                </small>
              )}

              {(() => {
                const fileValue = watch("attach_file");

                // URL for preview
                const fileUrl =
                  typeof fileValue === "string"
                    ? process.env.REACT_APP_IMG_URL + fileValue
                    : fileValue?.length > 0
                    ? URL.createObjectURL(fileValue[0])
                    : null;

                // Type detection
                const fileType =
                  typeof fileValue === "string"
                    ? fileValue.toLowerCase()
                    : fileValue?.[0]?.type;

                if (!fileUrl) return null;

                return (
                  <div className="image_holder mt-2">
                    {(fileType?.includes("image") ||
                      fileType?.endsWith(".jpg") ||
                      fileType?.endsWith(".jpeg") ||
                      fileType?.endsWith(".png")) && (
                      <img
                        src={fileUrl}
                        alt="Preview"
                        className="img_preview"
                      />
                    )}

                    {/* PDF */}
                    {(fileType === "application/pdf" ||
                      fileType?.endsWith(".pdf")) && (
                      <iframe
                        src={fileUrl}
                        style={{ maxWidth: "100px" }}
                        title="PDF"
                        className="img_preview"
                      />
                    )}

                    {/* WORD */}
                    {(fileType?.includes("word") ||
                      fileType?.endsWith(".doc") ||
                      fileType?.endsWith(".docx")) && (
                      <div>
                        <p>Word preview not supported</p>
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Open / Download Word File
                        </a>

                        <iframe
                          src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                          style={{ maxWidth: "100px" }}
                          title="Word Preview"
                          className="img_preview"
                        />
                      </div>
                    )}

                    {/* EXCEL */}
                    {(fileType?.includes("spreadsheet") ||
                      fileType?.endsWith(".xlsx") ||
                      fileType?.endsWith(".xls")) && (
                      <div className="img_preview">
                        <p>Excel preview not supported</p>
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Open / Download Excel File
                        </a>
                      </div>
                    )}
                  </div>
                );
              })()}
            </Form.Group>
          </div>

          {/* Tested By */}
          <div className="col-xl-4 col-md-6">
            <Form.Group className="form_group">
              <Form.Label>Tested By</Form.Label>
              <Controller
                name="tested_by_id"
                control={control}
                rules={{ required: "Test Type is required" }}
                render={({ field }) => (
                  <Select
                    options={all_teseted_by}
                    value={
                      all_teseted_by?.find((o) => o.value === field.value) ||
                      null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />
              {errors.tested_by_id && (
                <Form.Text className="text-danger">
                  {errors.tested_by_id.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
        </div>

        {/* Footer */}
        <div className="permission_btn_holder">
          <Button className="permission_btn No_btn" onClick={() => reset()}>
            Reset
          </Button>
          <Button
            className="permission_btn Yes_btn"
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </Button>
        </div>
      </div>
    </section>
  );
}

export default Use_Reference_Material_Form;
